import React, {useEffect} from "react";
import {addUserAsAdminInCloud, getAllCompanies} from "../../../services/AdminService";
import {DropdownButton, Alert, Button, Dropdown, Form, Container, Modal} from "react-bootstrap";
import LoadingLoginScreen from "../../../components/LoadingLoginScreen";


export const AdminAddUser = () => {

    const [error, setError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [companyReference, setCompanyReference] = React.useState('');
    const [errorText, setErrorText] = React.useState("");
    const [companies, setCompanies] = React.useState([]);

    const emailRef = React.useRef();
    const firstNameRef = React.useRef();
    const lastNameRef = React.useRef();
    const [allowWebRef, setAllowWebRef] = React.useState(false);

    const passwordRef = React.useRef();
    const [superAdminRef, setSuperAdminRef] = React.useState(false);

    let timer;

    useEffect(() => {
        const getCompanies = async () => {
            setCompanies(await getAllCompanies());
        }
        getCompanies().then(() => {
            setError(true);
            setErrorText("Alla företag inladdade")

            timer = setTimeout(() => {
                setError(false);
            }, 5000);

        });
    }, []);

    const handleSelect = (e) => {
        setAllowWebRef(e);
    }
    const handleSuperAdminSelect = (e) => {
        setSuperAdminRef(e);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!emailRef.current.value) {
            setError(true);
            setErrorText("Ange en Email-adress")
        } else if (!firstNameRef.current.value) {
            setError(true);
            setErrorText("Ange ett förnamn")
        } else if (!lastNameRef.current.value) {
            setError(true);
            setErrorText("Ange ett efternamn")
        } else if (!allowWebRef) {
            setError(true);
            setErrorText("Ange en behörighetsgrad")
        } else if (!companyReference) {
            setError(true);
            setErrorText("Ange ett företag")
        } else if (!passwordRef.current.value) {
            setError(true);
            setErrorText("Ange ett lösenord (användaren kan och borde byta lösenordet själv senare");
        } else if (passwordRef.current.value.length < 6) {
            setError(true);
            setErrorText("Lösenordet måste vara minst 6 tecken");

        } else {


            try {
                await addUserAsAdminInCloud(
                    firstNameRef.current.value,
                    lastNameRef.current.value,
                    emailRef.current.value,
                    companyReference,
                    allowWebRef,
                    passwordRef.current.value,
                    superAdminRef,
                ).catch((e) => {
                        setError(true);
                        setErrorText("Fel uppstod", e)
                    }
                ).finally(() => {
                        setError(true);
                        setErrorText(`Användare tillagd`);
                    }
                );

            } catch (e) {

                console.log("ERROR", e)
            }
        }
        setLoading(false);
    }

    return (
        <>

            {
                loading ? <LoadingLoginScreen/> :
                    <Form onSubmit={handleSubmit}
                          style={{padding: "30px", margin: " 30px"}}
                    >

                        {error ? <Alert variant={"secondary"}>{errorText}</Alert> : null}
                        {companies ?

                            <Dropdown>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    Välj Företag
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {companies.map((company) =>
                                        <Dropdown.Item
                                            key={company.id}
                                            eventKey={company.id}
                                            onSelect={function (evt) {
                                                setCompanyReference(evt)
                                            }}
                                        >{company.companyName}, {company.amountofAccounts} lediga
                                            licenser</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                            :
                            <p>Ange ett företag för att kunna välja Företagsadmin</p>

                        }

                        {companyReference ? (
                                <span>{companyReference}</span>
                            ) :
                            (
                                <span>Inget företag valt</span>
                            )}


                        <Form.Group id="email">
                            <Form.Label>
                                E-post
                            </Form.Label>
                            <Form.Control
                                type="email"
                                ref={emailRef}
                                placeholder="karl@karlsson.se"
                            >
                            </Form.Control>
                        </Form.Group>


                        <Form.Group id="password">
                            <Form.Label>
                                Lösenord
                            </Form.Label>
                            <Form.Control
                                type="text"
                                ref={passwordRef}
                                placeholder="*******"
                            >
                            </Form.Control>
                        </Form.Group>

                        <Form.Group id="firstName">
                            <Form.Label>
                                Förnamn
                            </Form.Label>
                            <Form.Control type="text"
                                          ref={firstNameRef}
                                          placeholder="Karl"
                            >

                            </Form.Control>
                        </Form.Group>

                        <Form.Group id="lastName">
                            <Form.Label>
                                Efternamn
                            </Form.Label>
                            <Form.Control
                                type="text"
                                ref={lastNameRef}
                                placeholder="Karlsson"
                            >

                            </Form.Control>
                        </Form.Group>

                        <Container style={{margin: '10px'}}>
                            <Form.Group>

                                <DropdownButton
                                    alignRight
                                    title="Ange App/Webb-behörighet"
                                    id="dropdown-menu-align-right"
                                    onSelect={handleSelect}
                                    style={{margin: '5px'}}

                                >
                                    <Dropdown.Item eventKey="Webb">Webb</Dropdown.Item>
                                    <Dropdown.Item eventKey="App">App</Dropdown.Item>
                                </DropdownButton>
                                {allowWebRef ?
                                    <label>
                                        {allowWebRef}

                                    </label> : <label>Ange Webb/App-behörighet</label>}
                            </Form.Group>

                            <Form.Group>

                                <DropdownButton
                                    alignRight
                                    title="Är användaren Leadtub-admin?"
                                    id="dropdown-menu-align-right"
                                    onSelect={handleSuperAdminSelect}
                                    style={{margin: '5px'}}

                                >
                                    <Dropdown.Item eventKey="none">Ej SuperAdmin</Dropdown.Item>
                                    <Dropdown.Item eventKey="superadmin">Superadmin</Dropdown.Item>
                                </DropdownButton>

                                {superAdminRef ?
                                    <label>
                                        {superAdminRef}

                                    </label> : <label>Ange Leadtubadmin-behörighet</label>}
                            </Form.Group>
                            <Button
                                style={{margin: '5px'}}

                                onClick={handleSubmit}
                                disabled={loading}
                                variant="primary" type="submit">
                                Skapa Användare
                            </Button>
                        </Container>


                    </Form>
            }

        </>
    )
}
